<app-page-shell>
  <app-page-hero eyebrow="CRM Contracts" title="Contract Templates" subtitle="Reusable rich text section templates for generated commercial agreements.">
    <div actions>
      <p-button label="Create Template" icon="fa-solid fa-plus" routerLink="/contracts/templates/create"></p-button>
    </div>
  </app-page-hero>

  <app-page-data-panel title="Templates" [resultText]="templates().length + ' templates'">
    <p-table [value]="templates()" styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Title</th>
          <th>Type</th>
          <th>Job Type</th>
          <th>Language</th>
          <th>Status</th>
          <th style="width: 8rem">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{ template.title }}</td>
          <td>{{ template.contractType || '-' }}</td>
          <td>{{ template.jobType || '-' }}</td>
          <td>{{ template.languageCode || 'en' }}</td>
          <td><p-tag [value]="template.active ? 'Active' : 'Inactive'" [severity]="template.active ? 'success' : 'secondary'"></p-tag></td>
          <td><p-button label="Edit" size="small" severity="secondary" [routerLink]="['/contracts/templates/edit', template.templateId]"></p-button></td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
